import { ReqParams } from "@/types";
import { withDefaultCountryFirst } from "@/utils/country";
import axiosInstance from "./axiosInstance";


export default class AuthService {
  static async login(params: ReqParams = {}) {
    const response = await axiosInstance.post("/auth/login", params, { suppressAuthRedirect: true });
    return response.data;
  }

  static async logout(params: ReqParams = {}) {
    const response = await axiosInstance.post("/auth/logout", params, {
      skipGlobalLoader: true,
    });
    return response.data;
  }

  static async forgotPassword(params: ReqParams = {}) {
    const response = await axiosInstance.post("/auth/forgot-password", params);
    return response.data;
  }

  static async verifyForgetPasswordOTP(params: ReqParams = {}) {
    const response = await axiosInstance.post("/auth/verify-otp", params);
    return response.data;
  }

  static async verifyLoginOTP(params: ReqParams = {}) {
    const response = await axiosInstance.post("/auth/login-with-otp", params);
    return response.data;
  }

  static async resetPassword(params: ReqParams = {}) {
    const response = await axiosInstance.post("/auth/reset-password", params);
    return response.data;
  }

  static async getProfile(params: ReqParams = {}) {
    const response = await axiosInstance.get("/auth/profile", { params });
    return response.data;
  }

  static async getCustomerTenants(params: { email: string }) {
    return axiosInstance.post("/customer/get-customer-tenants", params, {
      suppressAuthRedirect: true,
      skipGlobalLoader: true,
    });
  }

  static async customerLogin(params: { email: string, password: string, tenantId: string }) {
    return axiosInstance.post("/customer/login", params, { suppressAuthRedirect: true });
  }

  static async loginTakeover(params: { takeoverToken: string; action: string }) {
    const response = await axiosInstance.post("/auth/login/takeover", params, { suppressAuthRedirect: true });
    return response.data;
  }

  static async resendLoginOTP(params: { email: string; userType?: string; tenantId?: string | number }) {
    const payload: ReqParams = { email: params.email, purpose: "2fa" };
    if (params.tenantId) {
      payload.tenantId = params.tenantId;
    } else if (params.userType) {
      payload.userType = params.userType;
    }
    const response = await axiosInstance.post("/auth/resend-otp", payload, {
      suppressAuthRedirect: true,
      skipGlobalLoader: true,
    });
    return response.data;
  }

  static async resendForgotPasswordOTP(params: { email: string }) {
    const response = await axiosInstance.post("/auth/resend-otp", { email: params.email, purpose: "password_reset" }, {
      suppressAuthRedirect: true,
      skipGlobalLoader: true,
    });
    return response.data;
  }

  /** Country list for every country dropdown, with Nigeria moved to the top. */
  static async getCountires() {
    const response = await axiosInstance.get("/master/countries");
    const body = response.data;
    if (!Array.isArray(body?.data)) return body;

    return {
      ...body,
      data: withDefaultCountryFirst(body.data, (country: { name?: string }) => country?.name),
    };
  }
}
